import { createFileRoute } from '@tanstack/react-router';
import { TemplatesSettingsPage } from '../features/settings/TemplatesSettingsPage';

export const Route = createFileRoute('/settings/templates')({
  component: TemplatesSettingsPage,
});
